<template>
  <v-card style="width: 450px">
    <v-col align="center" class="pa-4">

      <h3 class="mt-5 mb-4">{{ $t("airStation.title") }}</h3>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("airStation.coordinates") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">
            {{ geoCoordinates[0] | toFixed3 }} : {{ geoCoordinates[1] | toFixed3 }}
          </v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("airStation.stationId") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ properties.code }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("airStation.name") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ properties.name }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("airStation.pm25") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ properties.pm2_5 }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("airStation.measurementTime") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ formatDate(properties.time) }}</v-card-text>
        </v-col>
      </v-row>

    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "AirPassportClarity",
  props: {
    properties: {
      type: Object,
      required: true
      // { code: Number, name: String, pm2_5: Number, time: String }
    },
    geoCoordinates: {
      type: Array,
      required: true
      // [lon: Number, lat: Number]
    }
  },
  filters: {
    toFixed3(value) {
      return Number(value).toFixed(3);
    }
  },
  methods: {
    formatDate(dateString) {
      const opts = { year: "numeric", month: "long", day: "numeric", hour: '2-digit', minute: '2-digit' };
      return new Date(dateString).toLocaleDateString(undefined, opts);
    }
  }
};
</script>

<style scoped>
::v-deep .v-input__slot {
  margin: 0;
  max-height: 32px;
  min-height: 32px !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-card-text {
  padding: 0;
  font-size: 13px;
}
</style>
